import { render, staticRenderFns } from "./SimpleList.vue?vue&type=template&id=66ea1a4b"
import script from "./SimpleList.vue?vue&type=script&lang=js"
export * from "./SimpleList.vue?vue&type=script&lang=js"
import style0 from "./SimpleList.vue?vue&type=style&index=0&id=66ea1a4b&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VBtn,VCardText,VDataTable,VIcon,VProgressLinear})
